var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('json-excel',{staticClass:"btn btn-warning",attrs:{"fetch":_vm.fetchData,"fields":_vm.json_fields,"worksheet":"Product","name":"product_inventory.xls"}},[_vm._v(" Download Excel ")])}
var staticRenderFns = []

export { render, staticRenderFns }